module.exports = __webpack_public_path__ + "img/1.0d81dce7.jpg";